import { registerPlugin } from '@capacitor/core'
import { isNativeApp } from './native'
import { fromBase64 } from '../solo2/bridge'

/**
 * iOS app: a native document picker that starts in the app's own folder (On My iPhone › Mala
 * Racing). On the website the ordinary file input is used instead.
 */
interface FilePickerPlugin {
  pick(o: { extensions: string[] }): Promise<{ files: { name: string; data: string; size: number }[]; skipped: string[]; cancelled?: boolean }>
}
const FilePicker = registerPlugin<FilePickerPlugin>('FilePicker')

export const nativePickerAvailable = isNativeApp

/** Resolves with File objects, or an empty list when the user cancelled. */
export async function pickSessionFiles(): Promise<{ files: File[]; skipped: string[] }> {
  const r = await FilePicker.pick({ extensions: ['xrk', 'xrz', 'hrz'] })
  const files = r.files.map((f) => {
    const bytes = fromBase64(f.data)
    return new File([bytes as BlobPart], f.name)
  })
  return { files, skipped: r.skipped ?? [] }
}
